class NotReportableException extends Error {
	constructor(message: string) {
		super(message)
		this.name = "NotReportableException"
	}
}

export default NotReportableException
